/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';

const graphColors = [
  colors.P300,
  colors.G300,
  colors.R300,
  colors.B300,
  colors.T300,
  colors.Y300,
];

type Node = {
  isFocused?: boolean;
  colorIndex: number;
};

export const Graph = styled.svg({
  transform: 'scaleX(-1)',
});

/* remove this disable once https://github.com/YozhikM/stylelint-a11y/issues/38 is addressed */
export const Node = styled.circle<Node>(({ isFocused, colorIndex }) => ({
  r: isFocused ? 5 : 3,
  cursor: 'pointer',
  transition: 'r 0.3s ease-out',
  strokeWidth: '4px',
  /* This is to give the circle a larger hit target for hover */
  stroke: isFocused ? graphColors[colorIndex] : 'transparent',
  fill: isFocused ? colors.N0 : graphColors[colorIndex],

  '&:hover, &:focus': {
    r: 5,
    fill: colors.N0,
    stroke: graphColors[colorIndex],
  },

  '@media screen and (prefers-reduced-motion: reduce)': {
    /* https://css-tricks.com/revisiting-prefers-reduced-motion-the-reduced-motion-media-query/ */
    transitionDuration: '0.001ms',
  },
}));

export const Path = styled.path<Node>(({ colorIndex }) => ({
  fill: 'none',
  strokeWidth: '1px',
  stroke: graphColors[colorIndex],
}));

export const Column = styled.rect({
  stroke: 'transparent',
  fill: 'transparent',
});
